import { render, staticRenderFns } from "./InfoElements.vue?vue&type=template&id=c5b2592c&scoped=true&"
import script from "./InfoElements.vue?vue&type=script&lang=ts&"
export * from "./InfoElements.vue?vue&type=script&lang=ts&"
import style0 from "./InfoElements.vue?vue&type=style&index=0&id=c5b2592c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b2592c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
